"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeService = void 0;
const MAX_COUNT = 20000;
const MINUTE_CACHE_KEY_SIZE = 60 * 1000;
const DAY_CACHE_KEY_SIZE = 24 * 60 * 60 * 1000;
// toLocaleString is quite slow (upto 5ms, so we dont want to recompute it if we can help it!)
class DateTimeService {
    constructor() {
        this.__priority = 100;
        this.DATE_CACHE = {};
        this.DATE_TIME_CACHE = {};
        this.ISO_CACHE = {};
        this.COUNT = 0;
    }
    checkReset() {
        this.COUNT++;
        if (this.COUNT > MAX_COUNT) {
            this.COUNT = 0;
            this.DATE_CACHE = {};
            this.DATE_TIME_CACHE = {};
            this.ISO_CACHE = {};
        }
    }
    getDate(iso) {
        const searchString = iso.slice(0, -5) + '.000Z';
        return this.ISO_CACHE[searchString] || (this.ISO_CACHE[searchString] = new Date(searchString));
    }
    getTime(iso) {
        return this.getDate(iso).getTime();
    }
    formatDate(value) {
        const date = typeof value === 'string' ? this.getDate(value) : value;
        const dateKey = Math.floor(date.getTime() / DAY_CACHE_KEY_SIZE);
        const dateCache = this.DATE_CACHE[dateKey];
        if (dateCache != null) {
            return dateCache;
        }
        const locale = 'en-GB';
        const output = `${date.toLocaleString(locale, { month: 'short', day: '2-digit' })}, ${date.toLocaleString(locale, { year: 'numeric' })}`;
        this.DATE_CACHE[dateKey] = output;
        this.checkReset();
        return output;
    }
    formatDateTime(value) {
        if (value == null) {
            return '';
        }
        const date = typeof value === 'string' ? this.getDate(value) : value;
        const dateKey = Math.floor(date.getTime() / MINUTE_CACHE_KEY_SIZE);
        const dateCache = this.DATE_TIME_CACHE[dateKey];
        if (dateCache != null) {
            return dateCache;
        }
        const locale = 'en-GB';
        var output = this.formatDate(date) + ' ' + date.toLocaleString(locale, { hour: '2-digit', minute: '2-digit', hour12: true });
        this.DATE_TIME_CACHE[dateKey] = output;
        this.checkReset();
        return output;
    }
    padNumber(num) {
        var norm = Math.abs(Math.floor(num));
        return (norm < 10 ? '0' : '') + norm;
    }
    formatTimezoneDate() {
        var now = new Date();
        var tzo = -now.getTimezoneOffset();
        var dif = tzo >= 0 ? '+' : '-';
        return (now.getFullYear() +
            '-' +
            this.padNumber(now.getMonth() + 1) +
            '-' +
            this.padNumber(now.getDate()) +
            'T' +
            this.padNumber(now.getHours()) +
            ':' +
            this.padNumber(now.getMinutes()) +
            ':' +
            this.padNumber(now.getSeconds()) +
            dif +
            this.padNumber(tzo / 60) +
            ':' +
            this.padNumber(tzo % 60));
    }
}
exports.DateTimeService = DateTimeService;
//# sourceMappingURL=date.time.service.js.map